module.exports = __webpack_public_path__ + "img/logo-government-10.a7ec74f3.png";